export default __webpack_public_path__ + "static/media/2.ea27b614.jpg";